export default function Registration() {
  return (
    <section id="inscricao" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Inscrição e Pagamento
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Taxa de Inscrição */}
          <div className="bg-gray-50 p-8 rounded-xl border-2 border-gray-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Taxa de Inscrição</h3>
            </div>
            <div className="mb-6">
              <p className="text-4xl font-bold text-orange-500 mb-2">R$ 50,00</p>
              <p className="text-base text-gray-600">Piloto individual</p>
            </div>
          </div>

          {/* Pagamento via PIX */}
          <div className="bg-gray-50 p-8 rounded-xl border-2 border-gray-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-bank-card-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Pagamento via PIX</h3>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-gray-600 mb-1">Chave (CNPJ)</p>
                <p className="text-lg font-semibold text-gray-900">54320342/0001-18</p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Nome</p>
                <p className="text-lg font-semibold text-gray-900">JMR Soluções</p>
              </div>
            </div>
          </div>
        </div>

        {/* Regras */}
        <div className="bg-orange-500/10 border-l-4 border-orange-500 p-6 sm:p-8 rounded-lg mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-4">Regras Importantes</h4>
          <ul className="space-y-3">
            <li className="flex items-start">
              <i className="ri-calendar-line text-orange-500 text-xl mr-3 mt-1"></i>
              <span className="text-base text-gray-700"><strong>Prazo final:</strong> 01/02/2026 às 23:59 (Horário de Brasília)</span>
            </li>
            <li className="flex items-start">
              <i className="ri-close-circle-line text-orange-500 text-xl mr-3 mt-1"></i>
              <span className="text-base text-gray-700"><strong>Sem reembolso</strong> após confirmação da inscrição</span>
            </li>
            <li className="flex items-start">
              <i className="ri-file-text-line text-orange-500 text-xl mr-3 mt-1"></i>
              <span className="text-base text-gray-700"><strong>Comprovante:</strong> deve ser enviado no formulário de inscrição</span>
            </li>
          </ul>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="https://forms.gle/tTc5BatSeyfwnPFJ8"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 text-base whitespace-nowrap cursor-pointer text-center"
          >
            Fazer inscrição
          </a>
          <a 
            href="https://chat.whatsapp.com/B8pgKs2dDmD57QLiP896ds"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-3 bg-gray-900 hover:bg-gray-800 text-white font-semibold rounded-lg transition-all duration-300 text-base whitespace-nowrap cursor-pointer text-center"
          >
            Entrar no grupo oficial
          </a>
        </div>
      </div>
    </section>
  );
}
